import React from 'react';
import { Col, Row } from 'react-bootstrap5';

export default function Index() {
  return (
    <section>
      <Row className="mb-3">
        <Col>
          <h1>Member Engagement</h1>
        </Col>
      </Row>
    </section>
  );
}
